import { useState, useRef } from "react";
import { 
	Flex, 
	Modal,
	ModalOverlay,
	ModalContent,
	ModalCloseButton,
	Text,
	useToast,
	Button,
	Input,
	Textarea,
	Image
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { isEmpty, toBase64 } from "../../utils";
import { useCreateQuestionnaireSection } from "../../hooks";

export function CreateQuestionnaireSectionModal({ questionnaire ,onClose }) {
	const toast = useToast();
	const navigate = useNavigate();
	const [loading, setLoading] = useState(false);
	const [title, setTitle] = useState("");
	const [description, setDescription] = useState("");
	const { mutateAsync } = useCreateQuestionnaireSection();

	async function handleSubmit(){
		setLoading(true);
		try {
			let data = await mutateAsync({
				title,
				description,
				questionnaireID: questionnaire.id
			});
			onClose();
			toast({
				status:"success",
				title:"Section created successfully!",
				position: 'top',
			})
		}
		catch(error) {
			toast({
				status:"error",
				title:error.message,
				position: 'top',
			})
		}
		setLoading(false);
	}

	return (
		<Modal isOpen={true} onClose={onClose} size="lg" isCentered motionPreset='slideInBottom'>
			<ModalOverlay />
			<ModalContent borderRadius="15px">
				<ModalCloseButton mr="-5px" borderRadius="30px" color="lightText" />
				<Flex p="20px 15px 0" direction="column">
					<Text variant="title" fontSize="21px" mb="20px">Create Section</Text>

					<Flex direction="column" mb="20px">
						<Text variant="subtitle">Title</Text>
						<Input
							type="text"
							placeholder="Set a great title"
							mt="10px"
							fontWeight="500"
							h="50px"
							p="10px"
							value={title}
							onChange={(e) => setTitle(e.target.value)}
							_focus={{
								borderColor:"primary",
								borderWidth:"2px"
							}}
						/>
					</Flex>
					<Flex direction="column" mb="30px">
						<Text variant="subtitle">Description</Text>
						<Textarea
							type="text"
							placeholder="Set a compelling description"
							mt="10px"
							fontWeight="500"
							rows={3}
							resize="none"
							p="10px"
							value={description}
							onChange={(e) => setDescription(e.target.value)}
							_focus={{
								borderColor:"primary",
								borderWidth:"2px"
							}}
						/>
					</Flex>
					<Flex flex="1" w="100%" p="10px 0" borderTop="1px solid #f3f3f3" mt="20px">
						<Flex as={Button} variant="primary" isDisabled={validate({ title, description })} isLoading={loading} onClick={handleSubmit} flex="2" h="50px" w="100%" p="14px 0" borderRadius="5px" align="center" justify="center" cursor="pointer">
							<Text variant="subtitle" color="white" fontSize="16px" fontWeight="600" opacity="1">Create section</Text>
						</Flex>
					</Flex>
				</Flex>
			</ModalContent>
		</Modal>
	)
}

function validate({ title, description }) {
	if (isEmpty(title)) {
		return true
	}
	if (isEmpty(description)) {
		return true;
	}

	return false;
}







